<template>
  <footer class="footer redfooter">
    <Credits />
    <div class="content has-text-centered">
      <p>
        <font color="white">© 2020 Virtual Red - Todos os direitos reservados.</font>
      </p>
    </div>
  </footer>
</template>
<script>

import Credits from "@/components/Footers/Credits";

export default {
  data() {
    return {};
  },
  components: {
    Credits: Credits
  },
  name: "internfooter"
};
</script>